import {UserTracker} from "../index.js";

const eventDics = {
    "request-service-click": "integration-setting:request-service-click:click", // 희망 연동 서비스 요청
    "show-more-detail-click": "integration-setting:show-more-detail-click:click", // 연동 자세히 알아보기
    "connect-button-click": "integration-setting:connect-button-click:click", // 연동
    "remove-button-click": "integration-setting:remove-button-click:click", // 연동 해제
}

export const IntegrationSettingTracker = () => {
    const Tracker = Object.create(UserTracker);
    Tracker.track = (eventName, value = null) => {
        const event = eventDics[eventName];
        if (!event) return;

        return Tracker.trackAction({event: event, value, data: {}});
    }

    return Tracker;
}
